<template>
  <Card class="m-2">
    <template #title="">
      <span
        v-tooltip="`สำหรับตรวจสอบ สถานะของ Shipment และปิด Shipment แบบ Manual`"
      >
        Shipment Report
      </span>
    </template>
    <template #content="">
      <div class="grid formgrid">
        <div class="col-4 xl:col-3 md:col-4 field p-fluid">
          <label for="selectedDate">Create Date</label>
          <Calendar id="selectedDate" selectionMode="range" v-model="selectedDate" autocomplete="off"></Calendar>
        </div>
        <!-- <div class="col-4 xl:col-3 md:col-4 field p-fluid">
          <label for="dselectedDate">Deliverry Date</label>
          <Calendar id="dselectedDate" v-model="dselectedDate" autocomplete="off"></Calendar>
        </div> -->
        <div class="col-4 xl:col-3 md:col-4 field p-fluid">
          <label for="dselectedDate">Deliverry Date</label>
          <Calendar id="dselectedDate" selectionMode="range" v-model="dselectedDate" autocomplete="off"></Calendar>
        </div>
        <div class="col-4 xl:col-3 md:col-4 field p-fluid">
          <label for="shipmentNo">Shipment No</label>
          <InputText id="shipmentNo" v-model="shipmentNo"></InputText>
        </div>
        <div
          class="
            col-4
            xl:col-2
            md:col-3
            field
            flex flex-column
            justify-content-end
          "
        >
          <Button
            icon="pi pi-search"
            label="ดึงข้อมูล"
            @click="onSearch"
          ></Button>
        </div>
        <div class="col-12">
          <DataTable
            class="p-datatable-sm"
            :value="filteredShipments"
            sortMode="multiple" 
            paginator
            :rows="10"
            dataKey="shipmentNo"
          >
            <template #empty=""> ไม่พบข้อมูล </template>
            <template #header="">
              <div class="grid">
                <div class="col-12 md:col-3 p-fluid mt-2">
                  <span class="p-float-label">
                    <InputText
                      id="searchString"
                      v-model="searchString"
                      class="p-inputtext-sm"
                    ></InputText>
                    <label for="searchString">ค้นหาข้อมูลในตารางด้านล่าง</label>
                  </span>
                </div>
              </div>
            </template>
            <template #footer="">
              <div class="flex justify-content-between">
                <span>จำนวนรายการทั้งหมด {{ shipments.length }} รายการ</span>
                <div class="btngrp">
                  <Button
                      icon="pi pi-download"
                      class="p-button-sm p-button-success"
                      label="Excel"
                      @click="onDownloadExcel"
                      :disabled="shipments.length === 0"
                    ></Button>
                    <div class="gap"></div>
                    <Button
                      icon="pi pi-download"
                      class="p-button-sm p-button-success"
                      label="Excel Detail"
                      :disabled="shipments.length === 0"
                      v-tooltip="`แสดงรายละเอียดการเข้าเยี่ยมทั้งหมด`"
                      @click="onShowDetail('Multiple')"
                    ></Button>
                </div>

              </div>
            </template>
            <Column field="shipmentNo" header="เลขที่ Shipment" sortable>
              <template #body="props">
                {{ parseInt(props.data.shipmentNo) }}
              </template>
            </Column>
            <Column field="plant" header="สาขา" sortable></Column>
            <Column field="owner" header="Dman" sortable></Column>
            <Column field="ownerName" header="ชื่อ Dman" sortable></Column>
            <Column field="createOn" header="วันที่สร้าง Shipment" sortable>
              <template #body="props">
                {{ formatDateTime(props.data.createOn) }}
              </template>
            </Column>
            <Column field="deliveryDate" header="วันที่ส่ง" sortable>
              <template #body="props">
                {{ formatDate(props.data.deliveryDate) }}
              </template>
            </Column>
            <Column field="completeOn" header="วันที่สิ้นสุด" sortable>
              <template #body="props">
                {{ formatDateTime(props.data.completeOn) }}
              </template>
            </Column>
            <Column
              field="totalBilling"
              header="จำนวนบิลทั้งหมด"
              sortable
              bodyStyle="text-align:right"
              headerStyle="text-align:right"
            ></Column>
            <Column
              field="paidBilling"
              header="จำนวนบิลที่สำเร็จแล้ว"
              sortable
              bodyStyle="text-align:right"
              headerStyle="text-align:right"
            ></Column>
            <Column
              field="haulBack"
              header="จำนวน Haulback"
              bodyStyle="text-align:right"
              headerStyle="text-align:right"
              sortable
            ></Column>
            <Column
              field="maximumSpeed"
              header="ความเร็วสูงสุด(KM/H)"
              bodyStyle="text-align:right"
              headerStyle="text-align:right"
              sortable
            >
              <template #body="props">
                {{ formatAmount(props.data.maximumSpeed) }}
              </template>
            </Column>
            <Column
              field="distance"
              header="ระยะทาง(KM)"
              bodyStyle="text-align:right"
              headerStyle="text-align:right"
              sortable
            >
              <template #body="props">
                {{ formatAmount(props.data.distance / 1000) }}
              </template>
            </Column>
            <Column bodyStyle="min-width: 10:rem" headerStyle="min-width:10rem">
              <template #body="props">
                <div class="flex flex-row justify-content-end" width="100%">
                  <Button
                    v-tooltip="`แสดงแผนที่`"
                    icon="pi pi-map"
                    class="p-button-rounded p-button-info"
                    @click="onShowMap(props.data.shipmentNo)"
                  ></Button
                  ><Button
                    v-tooltip="`แสดงรายละเอียดการเข้าเยี่ยม`"
                    icon="pi pi-list"
                    class="p-button-rounded p-button-info ml-1"
                    @click="onShowDetail(props.data.shipmentNo)"
                  ></Button>
                  <Button
                    v-tooltip.left="`ทำการปิด Shipment`"
                    v-if="!props.data.isComplete"
                    icon="pi pi-fast-forward"
                    class="p-button-rounded p-button-danger ml-1"
                    @click="onCompleteShipment(props.data.shipmentNo)"
                  ></Button>
                  <Button
                    class="p-button-rounded ml-1 p-button-success"
                    icon="pi pi-check"
                    v-else
                    v-tooltip.left="`Shipment เสร็จสิ้นแล้ว`"
                  ></Button>
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </template>
  </Card>

  <Sidebar v-model:visible="showMap" position="full">
    <div style="width: 100%; height: 85vh">
      <shipment-map
        :shipmentNo="selectedShipment"
        :showDetail="showShipmentDetail"
        :showmultipe="showmultipe" 
        :shipmentList="shipmentList"
        v-if="(selectedShipment && !showmultipe) || (shipmentList && showmultipe)"
      ></shipment-map>
      <div v-else>กรุณาระบุเลข Shipment ก่อน</div>
    </div>
  </Sidebar>
</template>

<script lang="ts">
import { usePlugin } from "@/plugins";
import {
  ShipmentCompleteRequest,
  ShipmentCompleteResponse,
  ShipmentProgressRequestDto,
  ShipmentProgressResponseDto,
} from "@/types";
import { saveAs } from "file-saver";
import { Workbook } from "exceljs";
import { useSessionStorage, useLocalStorage } from "@vueuse/core";
import { computed, defineComponent, onMounted, ref } from "vue";
import ShipmentMap from "@/components/ShipmentMap.vue";
import Fuse from "fuse.js";
import { stringifyQuery } from "vue-router";

export default defineComponent({
  name: "ShipmentCheck",
  components: { ShipmentMap },
  setup() {
    // const selectedDate = useSessionStorage(
    //   "shipmentCheck-selectedDate",
    //   new Date()
    // );
    // const dselectedDate = useSessionStorage(
    //   "shipmentCheck-dselectedDate",
    //   new Date()
    // );
    const selectedDate = ref();
    const dselectedDate = ref();
    const showmultipe = ref(false);
    const arrstring : string[] = [];
    const shipmentList = ref(arrstring);
    // const shipments = ref<ShipmentProgressResponseDto[]>([]);
    const shipments = useLocalStorage<ShipmentProgressResponseDto[]>(
      "shipmentCheck-shipments",
      []
    );

    const showMap = ref(false);
    const selectedShipment = ref("");

    const {
      axios,
      error,
      success,
      setLoading,
      formatDateTime,
      formatDate,
      formatAmount,
      dayjs,
      confirm,
    } = usePlugin();

    const shipmentNo = ref("");
    const searchString = ref("");
    const filteredShipments = computed(() => {
      if (!searchString.value) return shipments.value;
      const fuse = new Fuse(shipments.value, {
        keys: ["shipmentNo", "owner", "ownerName", "plant"],
      });
      const result = fuse.search(searchString.value);
      return result.map((x) => x.item);
    });

    const onSearch = async () => {
      try {
        setLoading(true);
        const result = await axios.post<ShipmentProgressResponseDto[]>(
          `api/v1/admin/shipment/progress`,
          {
            queryDate: selectedDate?.value?.[0] || null,
            queryDate2: selectedDate?.value?.[1] || null,
            dqueryDate: dselectedDate?.value?.[0] || null,
            dqueryDate2: dselectedDate?.value?.[1] || null,
            shipmentNo: shipmentNo.value,
          } as ShipmentProgressRequestDto
        );
        shipments.value = result.data ?? [];
        success("ดึงข้อมูลเรียบร้อยแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onShowMap = (shipmentNo: string) => {
      showMap.value = true;
      showShipmentDetail.value = false;
      selectedShipment.value = shipmentNo;
    };

    const showShipmentDetail = ref(false);
    
    const onShowDetail = (shipmentNoa: string) => {
      console.log("onshow detail got shipmentNo : ",shipmentNoa);
      console.log("onshow detail got shipmentNo : ",shipmentNoa);
      if(shipmentNoa == "Multiple") {
        selectedShipment.value = "";
        shipmentList.value = filteredShipments.value.map(obj => obj.shipmentNo);
        showmultipe.value = true;
      }else{
        selectedShipment.value = shipmentNoa;
        showmultipe.value = false;
        shipmentList.value = [];
      }
      console.log("onshow detail asign shipmentNo to component : ",selectedShipment.value);
      console.log("onshow detail asign shipmentlist to component : ");
      console.table(shipmentList.value);
      showMap.value = true;
      showShipmentDetail.value = true;
    };

    const onCompleteShipment = (shipmentNo: string) => {
      confirm.require({
        message: "กรุณายืนยันเพื่อทำการ mark complete shipment?",
        header: "Confirm Complete Shipment",
        acceptClass: "p-button-danger",
        accept: async () => {
          setLoading(true);
          try {
            const response = await axios.post<ShipmentCompleteResponse>(
              "api/v1/admin/shipment/complete",
              {
                shipmentNo: shipmentNo,
              } as ShipmentCompleteRequest
            );

            if (response.data.success) {
              const update = shipments.value.find(
                (x) => x.shipmentNo == shipmentNo
              );
              if (update) {
                update.isComplete = true;
                update.completeOn = dayjs().toDate();
              }
            }

            success("ทำการ mark complete สำเร็จแล้ว");
          } catch (e) {
            error(e);
          } finally {
            setLoading(false);
          }
        },
      });
    };

    const onDownloadExcel = async () => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Data");
      worksheet.addTable({
        name: "Table1",
        ref: "A1",
        columns: [
          { name: "Shipment No" },
          { name: "สาขา" },
          { name: "Dman" },
          { name: "ชื่อ Dman" },
          { name: "วันที่สร้าง Shipment" },
          { name: "วันที่ส่ง" },
          { name: "จัดส่งเสร็จสิ้นเมื่อ" },
          { name: "จำนวนบิลทั้งหมด" },
          { name: "จำนวนบิลที่ส่งสำเร็จ" },
          { name: "จำนวน Haulback" },
          { name: "ความเร็วสูงสุด (KM/h)" },
          { name: "ระยะทาง (KM)" },
        ],
        rows: shipments.value.map((x) => {
          return [
            parseInt(x.shipmentNo),
            x.plant,
            x.owner,
            x.ownerName,
            formatDateTime(x.createOn),
            formatDateTime(x.deliveryDate),
            formatDateTime(x.completeOn),
            x.totalBilling,
            x.paidBilling,
            x.haulBack,
            x.maximumSpeed,
            x.distance / 1000,
          ];
        }),
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);
      saveAs(blob, `shipments_${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`);
    };

    onMounted(() => {
      // selectedDate.value = dayjs(selectedDate.value).toDate();
      // selectedDate.value = null;
      // dselectedDate.value = dayjs(dselectedDate.value).toDate();
    });

    return {
      selectedDate,
      dselectedDate,
      shipmentNo,
      shipments,
      onSearch,
      formatDateTime,
      formatDate,
      formatAmount,
      showMap,
      onShowMap,
      onCompleteShipment,
      onDownloadExcel,
      selectedShipment,
      searchString,
      filteredShipments,
      showShipmentDetail,
      onShowDetail,
      showmultipe,
      shipmentList
    };
  },
});
</script>

<style>
.btngrp{
  display: flex;
}
.gap{
  margin: 0px 2px;
}
</style>
